var exports = {
  "h_": "xaee3c4fa--45c75f--description",
  "XQ": "xaee3c4fa--45c75f--description__title",
  "lY": "xaee3c4fa--45c75f--popup",
  "jR": "xaee3c4fa--45c75f--popup-appear",
  "yF": "xaee3c4fa--45c75f--divider",
  "L_": "xaee3c4fa--45c75f--desktop",
  "Hw": "xaee3c4fa--45c75f--mobile",
  "XI": "xaee3c4fa--45c75f--action",
  "x6": "xaee3c4fa--45c75f--button",
};

module.exports = exports;
